import { createContext, useCallback, useContext, useMemo, useState } from "react";

export const FlashContext = createContext();
let flashTimer;

export default function FlashProvider({ children }) {
  const [flashMessage, setFlashMessage] = useState({});
  const [visible, setVisible] = useState(false);

  const hideFlash = useCallback(() => {
    setVisible(false);
  }, []);

  const flash = useCallback((message, type, duration = 10) => {
    if (flashTimer) {
      clearTimeout(flashTimer);
      flashTimer = undefined;
    }
    setVisible(true);
    setFlashMessage({ message, type });

    if (duration) {
      flashTimer = setTimeout(hideFlash, duration * 1000);
    }
  }, [hideFlash]);

  const value = useMemo(
    () => ({ flash, hideFlash, flashMessage, visible }),
    [flash, flashMessage, hideFlash, visible]
  );

  return (
    <FlashContext.Provider value={value}>
      {children}
    </FlashContext.Provider>
  );
}

export function useFlash() {
  return useContext(FlashContext).flash;
}
